<template>
  <div class= "border border-gray-300 rounded-lg">
    <div class="flex flex-col m-4">
      <div class="h-12 flex justify-between">
        <div>
          <img src="../../../assets/images/logos/slack.png" class= "h-9 w-9" style= "max-width: none"/>
        </div>
        <div v-if="show" class="flex flex-row">
          <a class="inline-flex items-center h-10 px-3 mr-2 rounded-[12px] text-sm font-semibold bg-green-50 text-green-700 border border-green-200">
            {{ $t('Connected') }}
          </a>
          <a class="btn-secondary iconColor h-10" @click="this.openModal">
            <svg class="w-5 h-5 iconColor" viewBox="0 0 15 16" fill="#999999" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.47357 16L5.17929 13.4228C5.08774 13.4085 4.92425 13.3298 4.68883 13.1866C4.45341 13.0434 4.18529 12.8644 3.88447 12.6497L1.72643 13.6376L0 10.3517L1.88338 8.78389C1.85722 8.66935 1.841 8.55109 1.83472 8.4291C1.82792 8.30769 1.82452 8.16823 1.82452 8.01074C1.82452 7.91051 1.83106 7.79225 1.84414 7.65595C1.85722 7.52021 1.8703 7.36644 1.88338 7.19463L0 5.64832L1.72643 2.38389L3.90409 3.39329C4.08719 3.23579 4.28652 3.08546 4.50206 2.94228C4.71813 2.79911 4.94387 2.68456 5.17929 2.59866L5.47357 0H8.92643L9.22071 2.57718C9.46921 2.67741 9.68841 2.79195 9.87832 2.92081C10.0677 3.04966 10.2605 3.20716 10.4567 3.39329L12.6736 2.38389L14.4 5.64832L12.4381 7.25906C12.4643 7.40224 12.4808 7.52737 12.4876 7.63447C12.4939 7.74214 12.497 7.86756 12.497 8.01074C12.497 8.1396 12.4939 8.26502 12.4876 8.38701C12.4808 8.50842 12.4643 8.64072 12.4381 8.78389L14.3804 10.3517L12.6343 13.6376L10.4567 12.6282C10.2866 12.7857 10.1035 12.9289 9.90736 13.0577C9.71117 13.1866 9.48229 13.3083 9.22071 13.4228L8.92643 16H5.47357ZM7.18038 10.502C7.80818 10.502 8.34128 10.2586 8.77968 9.77181C9.21757 9.28501 9.43651 8.69799 9.43651 8.01074C9.43651 7.32349 9.21757 6.73646 8.77968 6.24966C8.34128 5.76286 7.80818 5.51946 7.18038 5.51946C6.53951 5.51946 6.00013 5.76286 5.56225 6.24966C5.12384 6.73646 4.90463 7.32349 4.90463 8.01074C4.90463 8.69799 5.12384 9.28501 5.56225 9.77181C6.00013 10.2586 6.53951 10.502 7.18038 10.502Z"/>
            </svg>
          </a>
        </div>
        <div v-else>
          <button 
          :disabled="this.isDisabled"
          class="btn-secondary h-10" @click="this.openModal">
            {{ $t('Connect') }}
          </button>
        </div>
      </div>
      <div class="">
        <h4 class="font-bold mt-4 text-neutral-900 text-base">{{ $t('Slack') }}</h4>
        <p class="text-sm mt-1 text-neutral-600">{{ $t('Receive notifications for new ideas and upvotes directly in your channels') }} </p>
      </div>
    </div>
    <!-- Dialog -->
    <Dialog :title="$t('Slack Settings')" v-model="dialogVisible">
      <form @submit.prevent="saveSlackSettings">
        <div class="px-4 pt-2 pb-4 sm:px-6 sm:pb-4" >
          <p class="alert alert--good mb-4" v-if="this.msg"> {{this.msg}}</p>
          <p class="bg-red-100 border border-red-300 text-red-900 px-6 py-4 rounded relative mb-4" v-if="this.error"> {{this.error}}</p>
          <label for="project_slack_hook_url" class="label">{{ $t('Slack Webhook URL') }}</label>
          <input
            class="input"
            type="text"
            :placeholder="$t('Paste your Slack Webhook URL here')"
            id="project_slack_hook_url"
            name="project[slack_hook_url]"
            v-model="slackHookUrls"
          />
          <div v-if="this.show"> 
            <p class="mt-4 text-neutral-600"> {{ $t('Select the boards and events that should trigger notifications in Slack') }} </p>
            <div class="mt-4 grid grid-cols-2 gap-4" >
              <!-- for boards -->
              <div>
                <h4 class="mb-4 font-bold text-neutral-900"> {{ $t('Boards') }}</h4>
                <div class="relative max-w-md mt-2"
                  v-for="board in this.currentBoards"
                  :key="board.id"
                >
                  <input
                    name="board[ids][]"
                    :id="'board-select'+board.id"
                    :value="board.id"
                    type="checkbox"
                    class="custom-checkbox cursor-pointer"
                    ref="boardSelect"
                    :checked= "board.slack_notification == true"
                  >
                  <label :for="'board-select'+board.id" class="text-neutral-700">
                    {{board.name}}
                  </label>
                </div>
              </div>
              <!-- for events -->
              <div>
                <h4 class="mb-4 font-bold text-neutral-900">{{ $t('Events') }}</h4>
                <div class="toggle-wrapper mt-4">
                  <div class="button--toggle">
                    <input type="checkbox" id="new_idea_slack_notification" class="checkbox" v-model="newIdeaSlackNotification" value="true" />
                    <div class="knobs"></div>
                    <div class="layer"></div>
                  </div>
                  <label for="new_idea_slack_notification" class="cursor-pointer">{{ $t('New ideas') }}</label>
                </div>

                <div class="toggle-wrapper mt-4">
                  <div class="button--toggle">
                    <input type="checkbox" id="new_comment_slack_notification" class="checkbox" v-model="newCommentSlackNotification" value="true" />
                    <div class="knobs"></div>
                    <div class="layer"></div>
                  </div>
                  <label for="new_comment_slack_notification" class="cursor-pointer">{{ $t('New comments') }}</label>
                </div>

                <div class="toggle-wrapper mt-4">
                  <div class="button--toggle">
                    <input type="checkbox" id="new_upvote_slack_notification" class="checkbox" v-model="newUpvoteSlackNotification" value="true" />
                    <div class="knobs"></div>
                    <div class="layer"></div>
                  </div>
                  <label for="new_upvote_slack_notification" class="cursor-pointer">{{ $t('New upvotes') }}</label>
                </div>

                <div class="toggle-wrapper mt-4">
                  <div class="button--toggle">
                    <input type="checkbox" id="status_change_slack_notification" class="checkbox" v-model="statusChangeSlackNotification" value="true" />
                    <div class="knobs"></div>
                    <div class="layer"></div>
                  </div>
                  <label for="status_change_slack_notification" class="cursor-pointer">{{ $t('Status changes') }}</label>
                </div>

                <div class="toggle-wrapper mt-4">
                  <div class="button--toggle">
                    <input type="checkbox" id="updates_slack_notification" class="checkbox" v-model="updatesSlackNotification" value="true" />
                    <div class="knobs"></div>
                    <div class="layer"></div>
                  </div>
                  <label for="updates_slack_notification" class="cursor-pointer">{{ $t('Updates') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="px-4 py-3 sm:px-6 flex items-center justify-end">
          <button type="submit" class="btn-main">
            <svg v-if="isLoading && !this.error" class="animate-spin h-5 w-5 mr-2" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" fill="#EA4F36" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ $t('Save') }}
          </button>
        </div>
      </form>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "../../components/dialog";

export default {
  props: ["boards", "saveSlackSettingsUrl", "currentProject", "slackHookUrl", "isDisabled"],
  data() {
    return {
      dialogVisible: false,
      currentBoards: this.boards,
      slackHookUrls: this.slackHookUrl,
      isLoading: false,
      error: '',
      msg: '',
      newCommentSlackNotification: false,
      updatesSlackNotification: false,
      newIdeaSlackNotification: false,
      statusChangeSlackNotification: false,
      newUpvoteSlackNotification: false,
    };
  },
  components: {
    Dialog,
  },
  computed:{
    show(){
      return !!this.slackHookUrl.length
    }
  },
  mounted() {
    // A never-saved event is null in the JSON; appending null to FormData
    // sends the string "null", which Rails reads as true.
    this.newCommentSlackNotification = !!this.currentProject.new_comment_slack_notification;
    this.updatesSlackNotification = !!this.currentProject.updates_slack_notification;
    this.newIdeaSlackNotification = !!this.currentProject.new_idea_slack_notification;
    this.statusChangeSlackNotification = !!this.currentProject.status_change_slack_notification;
    this.newUpvoteSlackNotification = !!this.currentProject.new_upvote_slack_notification;
  },
  watch: {
    dialogVisible(open) {
      if (!open) this.resetMessages();
    }
  },
  methods: {
    openModal() {
      this.dialogVisible = true;
    },
    resetMessages(){
      this.error= '';
      this.msg= '';
    },
    saveSlackSettings(event) {
      this.isLoading= true;
      let data = new FormData(event.target);
      data.append("project[new_comment_slack_notification]", this.newCommentSlackNotification);
      data.append("project[updates_slack_notification]", this.updatesSlackNotification);
      data.append("project[new_idea_slack_notification]", this.newIdeaSlackNotification);
      data.append("project[status_change_slack_notification]", this.statusChangeSlackNotification);
      data.append("project[new_upvote_slack_notification]", this.newUpvoteSlackNotification);
      if (data.get("board[ids][]") == null && this.show) {
        this.error = this.$t("Please select at least one board.")
        this.msg = ''
        return 
      }
      Rails.ajax({
        url: this.saveSlackSettingsUrl,
        type: "POST",
        data: data,
        dataType: "json",
        beforeSend: function () {
          return true;
        },
        success: (data) => {
          this.isLoading= false
          this.error = ''
          this.msg = this.$t('Your changes are successfully saved.')
          this.slackHookUrl = (!!this.slackHookUrls.length)? this.slackHookUrls: ''
          // window.location.reload();
        },
        error: (data, status) => {
          console.log(data);
        },
      });
    },
  }
}
</script>
<style scoped>
.iconColor:hover svg{
    fill: white;
}
</style>

<style scoped>
.toggle-wrapper {
  display: flex;
  align-items: center;
}

.button--toggle {
  position: relative;
  width: 74px;
  height: 36px;
  overflow: hidden;
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.button--toggle,
.button--toggle .layer {
  border-radius: 100px;
}

.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.knobs {
  z-index: 2;
}

.layer {
  width: 100%;
  background-color: #f5f5f5;
  transition: 0.3s ease all;
  z-index: 1;
  border: 1px solid gainsboro;
}

.button--toggle .knobs:before {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 28px;
  height: 28px;
  background-color: #d2d2d2;
  border-radius: 50%;
  transition: 0.3s ease all, left 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15);
}

.button--toggle .checkbox:active + .knobs:before {
  width: 46px;
  border-radius: 100px;
}

.button--toggle .checkbox:checked:active + .knobs:before {
  margin-left: -26px;
}

.button--toggle .checkbox:checked + .knobs:before {
  content: "";
  left: 42px;
  background-color: #3bd087;
}

.button--toggle .checkbox:checked ~ .layer {
  background-color: #d1f0e1;
  border-color: #a3e6c6;
}
</style>
